import { RootStateInterface } from './rootState';
import Vue from 'vue';
import Vuex from 'vuex';
import { core } from 'modules/core/stores/core';
import { auth } from 'modules/auth/stores/auth';
import { brokers } from 'modules/brokers/store/brokers';
import { personalAssistants } from 'modules/personalAssistant/store/personalAssistant';
import createPersistedState from 'vuex-persistedstate';
import { notifications } from '@/modules/notifications/store/notification';
import { clientsList } from '@/modules/clientslist/stores/clientsList';
import { introducer } from '@/modules/introducer/store/introducer';
import { revokeAllFileDisplayCache } from '@/modules/core/utils/fileDisplayCache';
import { messages } from '@/modules/messages/store/messages';
import { factFind } from '@/modules/settings/stores/factFind';
import { whatsNew } from '@/modules/whatsNew/store/whatsNew';
import { notes } from '@/modules/clients/stores/notes';
import { survey } from '@/modules/survey/stores/survey';
import { analytics } from '@/modules/adminSurvey/stores/analytics';
Vue.use(Vuex);

const store = new Vuex.Store<RootStateInterface>({
  state: {
    version: '1.0.0',
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  modules: {
    core,
    auth,
    brokers,
    personalAssistants,
    notifications,
    clientsList,
    introducer,
    messages,
    factFind,
    whatsNew,
    notes,
    survey,
    analytics,
  },
});

store.subscribe((mutation) => {
  if (mutation.type === 'auth/logout') {
    revokeAllFileDisplayCache();
    store.commit('core/setCompanyLogoBlob', null);
    store.commit('brokers/clearBrokerSnapshots');
    store.commit('brokers/update', null);
    store.commit('factFind/reset');
    store.commit('whatsNew/reset');
    store.commit('notes/reset');
    store.commit('clientsList/invalidateClientsByMortgageCache');
    store.commit('messages/setRecentChats', []);
  }
});

export default store;
